module.exports = __webpack_public_path__ + "assets/9007006af8f175a79dcf025838141a00.png";